import { getQueryExercisesSelect } from '@gymaholic/packages'
import pushRouterAction from 'modules/router/actions/push'
import handleEquipmentSyncReduxToUrlAction from 'modules/training/modules/training-exercises/actions/sync-redux-to-url/actions/handle-equipment/index.js'
import handleMusclesSyncReduxToUrlAction from 'modules/training/modules/training-exercises/actions/sync-redux-to-url/actions/handle-muscles/index.js'
import handleTypesSyncReduxToUrlAction from 'modules/training/modules/training-exercises/actions/sync-redux-to-url/actions/handle-types/index.js'

export default function syncReduxToUrlAction (pathname) {
  return (dispatch, getState) => {
    const query = getQueryExercisesSelect(getState())

    let searchParamsStr = ''
    if (query) {
      searchParamsStr = `q=${query}`
    }

    searchParamsStr = dispatch(
      handleMusclesSyncReduxToUrlAction({ searchParamsStr })
    )

    searchParamsStr = dispatch(
      handleEquipmentSyncReduxToUrlAction({ searchParamsStr })
    )

    searchParamsStr = dispatch(
      handleTypesSyncReduxToUrlAction({ searchParamsStr })
    )

    const searchPath = pathname + `?${searchParamsStr}`

    dispatch(pushRouterAction(searchPath))
  }
}
